const KEY = 'VUEX_STORE'
var _beforeUnload_time = null
import FileDownloader from '@/components/bigFileDownLoader/FileDownLoader'
import DownloadManager from '@/components/bigFileDownLoader/DownloadManager'
import store from '../store'
export default function (store) {
    // console.log(store)
    //保存仓库数据到本地
    window.addEventListener("beforeunload", () => {
        // _beforeUnload_time=new Date().getTime();
        // console.log(event)
        // event = event | window.event;
        // if(window.confirm('是否要离开本页面吗')){
        //     localStorage.setItem(KEY, JSON.stringify(store.state))
        // }else{
        var json = {}
        for (var key in store.state) {
            console.log(key)
            if (key != 'log' && key != 'downLoadStatus') {
                json[key] = store.state[key]

            }
        }
        window.localStorage.setItem(KEY, JSON.stringify(json))
        // }

    })
    //恢复仓库数据
    try {
        const localState = localStorage.getItem(KEY)
        if (localState) {
            store.replaceState(Object.assign({}, store.state, JSON.parse(localState)))
            setTimeout(() => {
                localStorage.removeItem(KEY);
            }, 1000)
        }
        const prefix = 'fileDownloaderState';

        // 获取所有本地存储键
        const keys = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.startsWith(prefix)) {
                keys.push(key);
            }
        }
        console.log(keys)
        if (keys.length > 0) {
            keys.forEach(key => {
                setTimeout(() => {
                    const manager = new DownloadManager();
                    const state = JSON.parse(localStorage.getItem(key));
                    const download = new FileDownloader({ url: state.url, cb: updateDate, timeCount: state.timeCount })
                    download.startDownload()
                    manager.addDownload({ [state.timeCount]: download })
                    // download.startDownload()
                    store.commit("downLoadStatus/setDownLoad", {
                        download: download,
                        id: state.timeCount,
                        downState: "0.00%",
                    })
                }, 1000)
            })
        }
    }
    catch {
        console.log('本地存储数据异常')
    }

}

function updateDate(res) {
    const { downState, downTime, fileName, pass, add, fileSize } = res
    console.log(downState, downTime, fileName, pass, add)
    store.commit("downLoadStatus/setDownLoad", {
        downState: (downState * 100).toFixed(2) + "%",
        id: downTime,
        fileName: fileName,
        fileSize: fileSize,
        pass: pass
    })
    // if (add) {
    //     loading.addList({
    //         downState: (downState * 100).toFixed(2) + "%",
    //         id: downTime,
    //         fileName: fileName,
    //         pass: pass
    //     })
    //     loading.open()
    //     setTimeout(() => {
    //         loading.closeT()
    //     }, 1000);
    // } else {
    //     loading.updateList({
    //         downState: (downState * 100).toFixed(2) + "%",
    //         id: downTime,
    //         fileName: fileName,
    //         pass: pass
    //     })
    // }


    // console.log(loading)
    // let messageElement = document.querySelector(`#download-notification-message${downTime}`);
    // if (messageElement) {
    //     messageElement.innerHTML = `<strong>正在下载,已下载 <i>${(downState * 100).toFixed(2)}%</i> </strong>`;
    // }
    // // loading.setText('正在下载，已下载' + (downState * 100).toFixed(2) + '%');
    // if (downState == 1) {
    //     loading.close()
    // }
}